import React, { useContext, useEffect } from 'react'
import {
  FancyModal,
  FancyContent,
  FancyShowcase,
  Avatar,
  FullBlockLoader,
  CircleLoader,
  Button
} from '@deal/components'
import { BusinessUserToShareComponent } from '#src/generated/graphql'
import styles from './styles.css'
import { AnalyticsContext } from '#src/containers/Analytics'
import { Link } from 'react-router-dom'
import { generateReferAFriendUrl } from '#src/services/referrals'

interface Props {
  onRequestClose: () => void
  entryPoint: Tracking.EntryPoint
  businessUserId: string
}

const ExpertReferralModal: React.SFC<Props> = ({ businessUserId, onRequestClose, entryPoint }) => {
  const analytics = useContext(AnalyticsContext)
  useEffect(() => {
    analytics &&
      analytics.events.referralPageEntryPointViewed({
        entry_point: entryPoint
      })
  }, [])

  return (
    <FancyModal isOpen={true} onRequestClose={onRequestClose}>
      <BusinessUserToShareComponent variables={{ id: businessUserId }}>
        {({ data }) => {
          if (data?.businessUser) {
            const { businessUser } = data
            const categoryName = businessUser.expertAttributes.category.singularDisplayName
            return (
              <>
                <FancyShowcase className={styles.expertShowcase}>
                  {businessUser.expertProfile && businessUser.expertProfile.profilePhoto && (
                    <Avatar
                      name={businessUser.displayName}
                      size={160}
                      src={businessUser.expertProfile.profilePhoto.url}
                      className={styles.expertAvatar}
                    />
                  )}

                  <div className={styles.expertDetails}>
                    <div className={styles.expertName}>{businessUser.shortName}</div>
                    {businessUser.expertProfile && categoryName && (
                      <div className={styles.expertHeadline}>your {categoryName} expert</div>
                    )}
                  </div>
                </FancyShowcase>
                <FancyContent className={styles.expertContent}>
                  <div className={styles.shareContainer}>
                    <div className={styles.title}>Give 10% off, get 10% off </div>
                    <div className={styles.subTitle}>
                      Share your unique referral link with friends! They’ll get expert advice and
                      handpicked recommendations plus 10% off their first purchase (up to $100 off).
                      When they buy, you’ll get 10% your next purchase.
                    </div>
                    <Link
                      to={generateReferAFriendUrl({ source: entryPoint, expert: businessUserId })}
                    >
                      <Button>Start sharing</Button>
                    </Link>
                  </div>
                </FancyContent>
              </>
            )
          } else {
            return <FullBlockLoader loader={CircleLoader} />
          }
        }}
      </BusinessUserToShareComponent>
    </FancyModal>
  )
}

export default ExpertReferralModal
